import { FilterSourceData } from "../typing";

export const useFilterCabinPrice = (list: FilterSourceData) => {
  const aircraftsOptionsMap = new Map<string, { tax: number; awardPoints: number }>();

  for (let index = 0; index < list.length; index++) {
    const item = list[index];
    const final_cabin_type = item.final_cabin_type;
    const target = aircraftsOptionsMap.get(item.final_cabin_type);
    if (!target) {
      aircraftsOptionsMap.set(final_cabin_type, {
        awardPoints: item.award_points,
        tax: item.surcharge,
      });
      continue;
    }

    if (
      item.award_points < target.awardPoints ||
      (item.award_points === target.awardPoints && item.surcharge < target.tax)
    ) {
      aircraftsOptionsMap.set(final_cabin_type, {
        ...target,
        awardPoints: item.award_points,
        tax: item.surcharge,
      });
    }
  }

  return aircraftsOptionsMap;
};
